import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PowerBiReportViewerComponent } from './power-bi-report-viewer.component';

@NgModule({
  declarations: [PowerBiReportViewerComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  exports: [PowerBiReportViewerComponent]
})
export class PowerBiReportViewerModule {}
